module.exports = flarum.core.compat['components/ReplyPlaceholder'];